import { Page } from '@/core/architecture'

import { ResaleApplicationDetailTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ResaleApplicationDetail Page
 * Implemented as a practical sample.
 */
export const ResaleApplicationDetail: Page = () => {
  const { state, actions } = useViewModel()

  return <ResaleApplicationDetailTemplate state={state} {...actions} />
}
